export const createSettingsServiceTypesRoutes = (basePath: string) =>
  ({
    index: basePath,
  }) as const;
